@if (atgard && (kontrakt$ | async); as kontrakt) {
  <rask-toggle-panel #togglePanel
    [ngClass]="{'highlight' : highlight}">
    <ng-container customHeader #customHeader>
      <rask-atgard-header [index]="index"></rask-atgard-header>
    </ng-container>
    <ng-container>
      <rask-virkeskop-validation-message
        entityType="atgard"
        [entityGuid]="atgard.guid">
      </rask-virkeskop-validation-message>
      <rask-tabs class="parent" layout="parent" [wrap]="true" [useRoute]="false">
        <!-- Detaljer avsiktligen ej "lazy-loaded" för att kunna köra frontend-valideringar -->
        @if (atgard) {
          <rask-tab label="Detaljer">
            <rask-atgard-detaljer>
            </rask-atgard-detaljer>
          </rask-tab>
        }
        @if (kontrakt.isLeveransvirke) {
          <rask-tab #volym label="Volym">
            @if (volym.visited) {
              <rask-atgard-volym>
              </rask-atgard-volym>
            }
          </rask-tab>
        }
        @if (!kontrakt.isLeveransvirke) {
          <rask-tab #forkalkyl label="Förkalkyl">
            @if (forkalkyl.visited) {
              <rask-atgard-forkalkyl>
              </rask-atgard-forkalkyl>
            }
          </rask-tab>
        }
        @if (showAtgardNVBTab()) {
          <rask-tab #nvb label="NVB/RISKBED.">
            @if (nvb.visited) {
              <rask-atgard-nvb>
              </rask-atgard-nvb>
            }
          </rask-tab>
        }
        <!-- Avsiktligen ej "lazy loaded" för front-end validering -->
        @if (isMarkberedForyngAtgActive) {
          <rask-tab label="MB/FÖR." routeId="mbf">
            <rask-atgard-mbf>
            </rask-atgard-mbf>
          </rask-tab>
        }
        @if (canHandleAvverkningsanmalan()) {
          <rask-tab #avverkningsanmalan label="ANM/ANS."
            [icon]="getIcon('avverkningsanmalan')" [ignoreIconClick]="true">
            <rask-atgard-avverkningsanmalan>
            </rask-atgard-avverkningsanmalan>
          </rask-tab>
        }
        @if (kontrakt.isLeveransvirke) {
          <rask-tab #transport label="Transport" route="transport">
            @if (transport.visited) {
              <rask-atgard-transport>
              </rask-atgard-transport>
            }
          </rask-tab>
        }
        @if (kontrakt.isLeveransvirke && isAnmSamRequired()) {
          <rask-tab #avverkningsanmalanSamrad label="ANM/SAM"
            >
            <rask-atgard-avverkningsanmalan-samrad>
            </rask-atgard-avverkningsanmalan-samrad>
          </rask-tab>
        }
        <rask-tab #status label="Status" routeId="status">
        @if (status.visited) {
            <rask-atgard-status
            (planeringsstatusChange)="onPlaneringsstatusChange($event)">
            </rask-atgard-status>
        }
        </rask-tab>

      </rask-tabs>
    </ng-container>
  </rask-toggle-panel>
} @else {
  <div class="atgard-loading placeholder-glow py-2 pr-2">
    <div class="col-7">
      <span class="placeholder col-2"></span>
      <span class="placeholder col-4"></span>
      <span class="placeholder col-4"></span>
      <span class="placeholder col-3"></span>
      <span class="placeholder col-5"></span>
      <span class="placeholder col-2"></span>
    </div>
  </div>
}
